import Component from '../core/Component';
import GoogleMapsLoader from 'google-maps';
import $ from 'jquery';
import debounce from 'lodash/debounce';
import { GOOGLE_MAPS_API_KEY } from '../core/config';

GoogleMapsLoader.KEY = GOOGLE_MAPS_API_KEY;

export default class GoogleMap extends Component {

    constructor($element) {
        super($element);

        this.latlng = null;
        this.isReady = false;

        this.$win = $(window);
    }

    prepare() {
        this.coords =  {
            lat: this.$element.data('lat'),
            lng: this.$element.data('lng')
        }

        GoogleMapsLoader.load(::this.render);

        this.$win.on('resize.googleMap orientationchange.googleMap', debounce(::this.center, 200));
    }

    render(google) {
        const latlng = new google.maps.LatLng(this.coords.lat, this.coords.lng);
        this.google = google;
        this.latlng = latlng;

        this.map = new google.maps.Map(this.element, {
            center: latlng,
            zoom: 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
        });

        // InfoWindow content
        var content = `
            <div class="">
                <div class=""></div>
                <img src="/assets/frontend/img/map-img.jpg" alt="">

                <div class="">
                    <p class="text">
                        <strong>Türkova 828</strong> <br>
                        149 00  Praha 4 - Chodov
                    </p>

                    <a href="#todo" class="button">Navigovat</a>
                </div>
            </div>
            `;

        // A new Info Window is created and set content
        var infowindow = new google.maps.InfoWindow({
            content: content
        });

        var marker = new google.maps.Marker({
            position: latlng,
            map: this.map,
            visible: false,
        });

        infowindow.open(this.map, marker);

        var contentString =
            `
            <div class="iw">
                <div class="">
                    <h2>Kancelář Praha</h2>
                    <p class="text">
                        <strong>Türkova 828</strong> <br>
                        149 00  Praha 4 - Chodov
                    </p>
                </div>
            </div>
            `;

        var infowindow = new google.maps.InfoWindow({
            content: contentString,
        });

        infowindow.open(this.map, marker);

        setTimeout(() => {
            this.isReady = true;
            this.center();
        }, 0);
    }

    center() {
        if (this.isReady) {
            this.google.maps.event.trigger(this.map,'resize');
            this.map.setCenter(this.latlng);
        }
    }

    destroy() {
        this.$element.detach();
        this.map = null;
        this.$win.off('.googleMap');
    }
}


// WEBPACK FOOTER //
// ./components/GoogleMap.js